export const asyncCondition = (
  conditionFunc: () => boolean,
  interval = 50,
  limit = -1
) => {
  return new Promise((resolve, reject) => {
    let intervalToken: NodeJS.Timeout | null = null;
    let attempt = 0;
    const checkCondition = () => {
      try {
        const result = conditionFunc();
        if (result) {
          if (intervalToken) clearInterval(intervalToken);
          resolve(result);
        } else {
          attempt += 1;
          if (attempt === limit) {
            if (intervalToken) clearInterval(intervalToken);
            reject(result);
          }
        }
        return result;
      } catch (err) {
        console.error("utils/asyncCondition", { err });
        return false;
      }
    };
    const firstAttempt = checkCondition();
    if (firstAttempt === true) return;
    intervalToken = setInterval(checkCondition, interval);
  });
};
